import { Environment, Html, Text, useGLTF, View } from "@react-three/drei";
import ContactProps from "./Props";
import Skydancer from "./Skydancer";
import { Physics } from "@react-three/rapier";
import { useRef } from "react"
import { useBreakpoints } from "../../hook/useBreakpoints";



export default function Contact(props) {
    const {isMobile, isDesktop} = useBreakpoints()
    const ref = useRef()
    if (ref.current) {
        ref.current.parentElement.style.pointerEvents = 'none'
    }
    return (
        <View className="view contact-view">
            <ContactProps camPosition={isMobile ? [0, 11, 60] : [0, 9, 40]} />
            <Physics debug>
                <Skydancer scale={1} position={[0, 0, 0]} />
            </Physics>
            <Text
                color="white"
                anchorX="center"
                anchorY="middle"
                position={isMobile ? [0, 18, -10] : [0, 9, -10]}
                fontSize={isMobile ? 1.5 : isDesktop ? 4 : 2.5 }
                // font="./font/Karrik-Regular.ttf"
                font="./font/Karrik-Regular.ttf"
            >
                LANCEZ VOUS
                <meshBasicMaterial attach="material" color="#FCF4F1" toneMapped={false} />
            </Text>
            <Html position={isMobile ? [0, 15, 0] : [0, 6, 0]} center>

                <a onClick={() =>
                    window.gtag("event", "contact_click", {
                        button_id: "contact_button",
                    })
                } href="#form">
                    <div className="btn-contact f20">
                        ENVOYER UN MESSAGE
                    </div>
                </a>

            </Html>
            {/* <Environment files="./env/envMap.hdr"/> */}
            <Environment preset="studio" />
        </View>
    )
}

useGLTF.preload('/models/skydancer-red.glb')